export const SITES = [
  { code: "District", label: "Eastern Sierra Unified School District", short: "DIST" },
  { code: "LVHS",     label: "Lee Vining High School",       short: "LVHS" },
  { code: "LVES",     label: "Lee Vining Elementary School", short: "LVES" },
  { code: "BES",      label: "Bridgeport Elementary School", short: "BES" },
  { code: "EBES",     label: "Edna Beaman Elementary School", short: "EBES" },
  { code: "CHS",      label: "Coleville High School",        short: "CHS" },
  { code: "AES",      label: "Antelope Elementary School",   short: "AES" },
];

export const SITE_LABEL = Object.fromEntries(SITES.map((s) => [s.code, s.label]));
export const SITE_SHORT = Object.fromEntries(SITES.map((s) => [s.code, s.short]));
export const SCHOOL_SITES = SITES.filter((s) => s.code !== "District");

// Soft-tone tag presets. Keep as literal strings so Tailwind picks them up at build time.
// `hex` is the accent color used for chart dots / dept dots that match this preset.
// `neon` is the glow shadow used by priority pills (they keep the classic backlit look).
// Dark-mode text uses the -100 tint (near-white, brighter than the previous -300)
// so status/dept/site pills are readable against the dark card backgrounds.
export const TAG_PRESETS = {
  zinc:    { label: "Neutral",  classes: "bg-zinc-100 text-zinc-700 border-zinc-200 dark:bg-zinc-500/25 dark:text-zinc-100 dark:border-zinc-400",       swatch: "#e4e4e7", hex: "#71717a", neon: "shadow-[0_0_6px_rgba(113,113,122,0.55)] dark:shadow-[0_0_10px_rgba(161,161,170,0.7)]" },
  slate:   { label: "Slate",    classes: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-500/25 dark:text-slate-100 dark:border-slate-400",    swatch: "#cbd5e1", hex: "#64748b", neon: "shadow-[0_0_6px_rgba(100,116,139,0.55)] dark:shadow-[0_0_10px_rgba(148,163,184,0.7)]" },
  red:     { label: "Red",      classes: "bg-red-100 text-red-700 border-red-200 dark:bg-red-500/25 dark:text-red-100 dark:border-red-400",          swatch: "#fca5a5", hex: "#dc2626", neon: "shadow-[0_0_10px_rgba(239,68,68,0.65)] dark:shadow-[0_0_14px_rgba(239,68,68,0.8)]" },
  rose:    { label: "Rose",     classes: "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-500/25 dark:text-rose-100 dark:border-rose-400",       swatch: "#fda4af", hex: "#e11d48", neon: "shadow-[0_0_10px_rgba(225,29,72,0.65)] dark:shadow-[0_0_14px_rgba(244,63,94,0.8)]" },
  amber:   { label: "Amber",    classes: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-500/25 dark:text-amber-100 dark:border-amber-400",    swatch: "#fcd34d", hex: "#d97706", neon: "shadow-[0_0_8px_rgba(249,115,22,0.6)] dark:shadow-[0_0_12px_rgba(249,115,22,0.75)]" },
  yellow:  { label: "Yellow",   classes: "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-500/25 dark:text-yellow-100 dark:border-yellow-400", swatch: "#fde047", hex: "#ca8a04", neon: "shadow-[0_0_6px_rgba(234,179,8,0.55)] dark:shadow-[0_0_10px_rgba(234,179,8,0.7)]" },
  emerald: { label: "Emerald",  classes: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-500/25 dark:text-emerald-100 dark:border-emerald-400", swatch: "#6ee7b7", hex: "#059669", neon: "shadow-[0_0_6px_rgba(16,185,129,0.55)] dark:shadow-[0_0_10px_rgba(16,185,129,0.7)]" },
  teal:    { label: "Teal",     classes: "bg-teal-100 text-teal-700 border-teal-200 dark:bg-teal-500/25 dark:text-teal-100 dark:border-teal-400",       swatch: "#5eead4", hex: "#0d9488", neon: "shadow-[0_0_6px_rgba(20,184,166,0.55)] dark:shadow-[0_0_10px_rgba(45,212,191,0.7)]" },
  green:   { label: "Green",    classes: "bg-green-100 text-green-800 border-green-200 dark:bg-green-500/25 dark:text-green-100 dark:border-green-400",    swatch: "#86efac", hex: "#16a34a", neon: "shadow-[0_0_6px_rgba(34,197,94,0.55)] dark:shadow-[0_0_10px_rgba(74,222,128,0.7)]" },
  cyan:    { label: "Cyan",     classes: "bg-cyan-100 text-cyan-700 border-cyan-200 dark:bg-cyan-500/25 dark:text-cyan-100 dark:border-cyan-400",       swatch: "#67e8f9", hex: "#0891b2", neon: "shadow-[0_0_6px_rgba(6,182,212,0.55)] dark:shadow-[0_0_10px_rgba(34,211,238,0.7)]" },
  sky:     { label: "Sky",      classes: "bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-500/25 dark:text-sky-100 dark:border-sky-400",          swatch: "#7dd3fc", hex: "#0284c7", neon: "shadow-[0_0_6px_rgba(14,165,233,0.55)] dark:shadow-[0_0_10px_rgba(56,189,248,0.7)]" },
  blue:    { label: "Blue",     classes: "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-500/25 dark:text-blue-100 dark:border-blue-400",       swatch: "#93c5fd", hex: "#2563eb", neon: "shadow-[0_0_6px_rgba(37,99,235,0.55)] dark:shadow-[0_0_10px_rgba(96,165,250,0.7)]" },
  indigo:  { label: "Navy",     classes: "bg-indigo-100 text-indigo-900 border-indigo-300 dark:bg-indigo-500/25 dark:text-indigo-100 dark:border-indigo-400", swatch: "#a5b4fc", hex: "#3730a3", neon: "shadow-[0_0_6px_rgba(79,70,229,0.55)] dark:shadow-[0_0_10px_rgba(129,140,248,0.7)]" },
  violet:  { label: "Violet",   classes: "bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-500/25 dark:text-violet-100 dark:border-violet-400", swatch: "#c4b5fd", hex: "#7c3aed", neon: "shadow-[0_0_6px_rgba(139,92,246,0.55)] dark:shadow-[0_0_10px_rgba(167,139,250,0.7)]" },
  fuchsia: { label: "Fuchsia",  classes: "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200 dark:bg-fuchsia-500/25 dark:text-fuchsia-100 dark:border-fuchsia-400", swatch: "#f0abfc", hex: "#c026d3", neon: "shadow-[0_0_6px_rgba(217,70,239,0.55)] dark:shadow-[0_0_10px_rgba(232,121,249,0.7)]" },
  pink:    { label: "Pink",     classes: "bg-pink-100 text-pink-700 border-pink-200 dark:bg-pink-500/25 dark:text-pink-100 dark:border-pink-400",       swatch: "#f9a8d4", hex: "#db2777", neon: "shadow-[0_0_6px_rgba(236,72,153,0.55)] dark:shadow-[0_0_10px_rgba(244,114,182,0.7)]" },
};
export const TAG_PRESET_KEYS = Object.keys(TAG_PRESETS);

export const DEFAULT_SITE_TAG_PRESETS = {
  District: "zinc",
  LVHS:     "red",
  LVES:     "red",
  BES:      "emerald",
  EBES:     "sky",
  CHS:      "indigo",
  AES:      "indigo",
};

// Module-level cache. Admins update this via TagSettings; other components read it.
let SITE_TAG_MAP = { ...DEFAULT_SITE_TAG_PRESETS };
let _subs = [];

export const getSiteTagMap = () => ({ ...SITE_TAG_MAP });
export const setSiteTagMap = (next) => {
  SITE_TAG_MAP = { ...DEFAULT_SITE_TAG_PRESETS, ...(next || {}) };
  _subs.forEach((fn) => { try { fn(SITE_TAG_MAP); } catch (err) { console.error("site-tag subscriber threw:", err); } });
};
export const subscribeSiteTags = (fn) => {
  _subs.push(fn);
  return () => { _subs = _subs.filter((f) => f !== fn); };
};

export const siteTagClass = (code) => {
  const preset = SITE_TAG_MAP[code] || DEFAULT_SITE_TAG_PRESETS[code] || "zinc";
  return TAG_PRESETS[preset]?.classes || TAG_PRESETS.zinc.classes;
};
export const siteAccentHex = (code) => {
  const preset = SITE_TAG_MAP[code] || DEFAULT_SITE_TAG_PRESETS[code] || "zinc";
  return TAG_PRESETS[preset]?.hex || "#71717a";
};

// ---- Department tag colors (IT/Maintenance/Custodial/Mechanic) — same preset system ----
export const DEPARTMENTS = ["IT", "Maintenance", "Custodial", "Mechanic"];
export const DEFAULT_DEPT_TAG_PRESETS = {
  IT:          "violet",
  Maintenance: "teal",
  Custodial:   "rose",
  Mechanic:    "amber",
};
let DEPT_TAG_MAP = { ...DEFAULT_DEPT_TAG_PRESETS };
let _deptSubs = [];
export const getDeptTagMap = () => ({ ...DEPT_TAG_MAP });
export const setDeptTagMap = (next) => {
  DEPT_TAG_MAP = { ...DEFAULT_DEPT_TAG_PRESETS, ...(next || {}) };
  _deptSubs.forEach((fn) => { try { fn(DEPT_TAG_MAP); } catch (err) { console.error("dept-tag subscriber threw:", err); } });
};
export const subscribeDeptTags = (fn) => {
  _deptSubs.push(fn);
  return () => { _deptSubs = _deptSubs.filter((f) => f !== fn); };
};
export const deptTagClass = (dept) => {
  const preset = DEPT_TAG_MAP[dept] || DEFAULT_DEPT_TAG_PRESETS[dept] || "zinc";
  return TAG_PRESETS[preset]?.classes || TAG_PRESETS.zinc.classes;
};
export const deptAccentHex = (dept) => {
  const preset = DEPT_TAG_MAP[dept] || DEFAULT_DEPT_TAG_PRESETS[dept] || "zinc";
  return TAG_PRESETS[preset]?.hex || "#71717a";
};

// ---- Status tag colors (Open/In Progress/Resolved/Closed) ----
export const STATUSES = ["Open", "In Progress", "Resolved", "Closed"];
export const DEFAULT_STATUS_TAG_PRESETS = {
  Open:          "indigo",
  "In Progress": "blue",
  Resolved:      "emerald",
  Closed:        "zinc",
};
let STATUS_TAG_MAP = { ...DEFAULT_STATUS_TAG_PRESETS };
let _statusSubs = [];
export const getStatusTagMap = () => ({ ...STATUS_TAG_MAP });
export const setStatusTagMap = (next) => {
  STATUS_TAG_MAP = { ...DEFAULT_STATUS_TAG_PRESETS, ...(next || {}) };
  _statusSubs.forEach((fn) => { try { fn(STATUS_TAG_MAP); } catch (err) { console.error("status-tag subscriber threw:", err); } });
};
export const subscribeStatusTags = (fn) => {
  _statusSubs.push(fn);
  return () => { _statusSubs = _statusSubs.filter((f) => f !== fn); };
};
export const statusTagClass = (status) => {
  const preset = STATUS_TAG_MAP[status] || DEFAULT_STATUS_TAG_PRESETS[status] || "zinc";
  return TAG_PRESETS[preset]?.classes || TAG_PRESETS.zinc.classes;
};

// ---- Priority tag colors (Low/Medium/High/Critical) + signature neon glow ----
export const PRIORITIES = ["Low", "Medium", "High", "Critical"];
export const DEFAULT_PRIORITY_TAG_PRESETS = {
  Low:      "emerald",
  Medium:   "yellow",
  High:     "amber",
  Critical: "red",
};
let PRIORITY_TAG_MAP = { ...DEFAULT_PRIORITY_TAG_PRESETS };
let _prioritySubs = [];
export const getPriorityTagMap = () => ({ ...PRIORITY_TAG_MAP });
export const setPriorityTagMap = (next) => {
  PRIORITY_TAG_MAP = { ...DEFAULT_PRIORITY_TAG_PRESETS, ...(next || {}) };
  _prioritySubs.forEach((fn) => { try { fn(PRIORITY_TAG_MAP); } catch (err) { console.error("priority-tag subscriber threw:", err); } });
};
export const subscribePriorityTags = (fn) => {
  _prioritySubs.push(fn);
  return () => { _prioritySubs = _prioritySubs.filter((f) => f !== fn); };
};
export const priorityTagClass = (priority) => {
  const preset = PRIORITY_TAG_MAP[priority] || DEFAULT_PRIORITY_TAG_PRESETS[priority] || "zinc";
  const p = TAG_PRESETS[preset] || TAG_PRESETS.zinc;
  return `${p.classes} ${p.neon || ""}`;
};

// ---- Per-site crest images (data URLs). Populated on AppShell mount. ----
let SITE_CRESTS = {};
let _crestSubs = [];
export const getSiteCrests = () => ({ ...SITE_CRESTS });
export const setSiteCrests = (next) => {
  SITE_CRESTS = { ...(next || {}) };
  _crestSubs.forEach((fn) => { try { fn(SITE_CRESTS); } catch (err) { console.error("site-crest subscriber threw:", err); } });
};
export const setSiteCrest = (code, dataUrl) => {
  if (dataUrl) SITE_CRESTS = { ...SITE_CRESTS, [code]: dataUrl };
  else { const n = { ...SITE_CRESTS }; delete n[code]; SITE_CRESTS = n; }
  _crestSubs.forEach((fn) => { try { fn(SITE_CRESTS); } catch (err) { console.error("site-crest subscriber threw:", err); } });
};
export const subscribeSiteCrests = (fn) => {
  _crestSubs.push(fn);
  return () => { _crestSubs = _crestSubs.filter((f) => f !== fn); };
};
export const siteCrest = (code) => SITE_CRESTS[code] || null;
